// extracted by mini-css-extract-plugin
export default {"piiRemovedIcon":"piiRemoved_piiRemovedIcon__lqq+x"};